
import { useTheme } from '../../../../redux/hooks/useTheme';
import { Link } from 'react-router-dom';
import { useUserDetails } from '../../../../redux/hooks/UserDetails';
import Logo from './Logo';
import { useLocation } from "react-router-dom";

export default function Footer() {
  const { theme } = useTheme();
  const location = useLocation();
  const {userDetail}=useUserDetails();
  const isLegalPage = location.pathname === "/privacy-policy" || location.pathname === "/terms-of-service" || location.pathname === "/prompt-gallery";
  return (
    <div  >
      <footer
        style={{
        // marginTop:'20px'
        }}
        className="border-gray-200 px-4 sm:px-0 footer-padding"
      >
        <div  style={{
            background: theme.footerBgg,
            paddingTop: isLegalPage
              ? "80px"                  
              : userDetail
              ? "60px"
              : "280px",
          }} className="mx-auto px-[15px]  pb-[50px]">
          <div style={{flexDirection:'column'}} className="flex lg:items-center gap-[20px] banner-fb-sub">
            {/* Left Section */}
            <div className="flex flex-col items-start lg:mb-0">
              <Link style={{ }} to="/">
              {/* <img
              src={theme.heroLogo} // Use src instead of background
              className="h-10 md:p-0"
              alt="Advance To Builder"
            /> */}
            <Logo />
              </Link>

             {/* // <div className="flex justify-center items-center"> */}
                {/* <div
              style={{
                display: 'flex',
                backgroundColor:'white',
                alignItems: 'center',
                border: '1px solid #d1d5db', // Match the input border color
                borderRadius: '8px', // Rounded edges for the wrapper
                overflow: 'hidden', // Ensure no overflow
                width: 'fit-content', // Adjust width dynamically
              }}
            >
                <input
                  type="email"
                  placeholder="name@email.com"
                  style={{
                    border: 'none', // Remove default border
                    outline: 'none', // Remove focus outline
                    padding: '10px 12px',
                    fontSize: '14px',
                    flex: '1', // Allow input to grow
                  }}
                  className="text-sm w-[200px]"
                />
                <button
                        className="text-white text-sm"
                        style={{
                          padding: '10px 16px',
                          border: 'none',
                          width:'99px',
                          background: 'linear-gradient(314.03deg, #FB5F65 -0.15%, #F378C9 100.63%)',
                          backgroundBlendMode: 'overlay',
                          cursor: 'pointer',
                          borderTopLeftRadius:'8px',
                          borderBottomLeftRadius:'8px',
                        }}
                      >
                    Send
              </button>
          </div> */}
             {/* // </div> */}

              {/* <p style={{marginBottom:'30px', color:theme.noSpam,fontSize:'14px', fontWeight:'400', lineHeight:'25.5px'
            }} className="text-xs text-gray-500 ">No Spam. Just Product Updates</p> */}

            </div>

            {/* Middle Section */}
            <div style={{ position: 'relative', top: '-12px', display: 'flex' }} className="flex footer-m">
              <div>
              {/* <h3 style={{color:theme.footerH3, fontSize:'16px', fontWeight:'500', lineHeight:'25.5px', cursor:'pointer'}} className="font-semibold text-gray-700 mb-2 footer-helping-links">Home</h3> */}
              {/* <ul className="text-sm text-gray-600 space-y-[6px]"> */}
                {/* <li className='footer-helping-links' style={{color:theme. footerli,  fontSize:'14px', fontWeight:'400', lineHeight:'25.5px'}}><Link to="/">Home</Link></li>
                <li className='footer-helping-links' style={{color:theme. footerli, fontSize:'14px', fontWeight:'400', lineHeight:'25.5px'}}><Link to="/prompt-gallery">Prompt Gallery</Link></li> */}
                {/* <li className='footer-helping-links' style={{color:theme. footerli,  fontSize:'14px', fontWeight:'400', lineHeight:'25.5px'}}><Link to="/features">Features</Link></li>
                <li className='footer-helping-links' style={{color:theme. footerli,  fontSize:'14px', fontWeight:'400', lineHeight:'25.5px'}}><Link to="/pricing">Pricing</Link></li> */}
              {/* </ul> */}
            </div>
             
            </div>
             <div>
                {/* <h3 style={{ color: theme.footerH3, fontSize: '16px', fontWeight: '500', lineHeight: '25.5px', cursor: 'pointer' }} className="font-semibold text-gray-700 mb-2 footer-helping-links">Company</h3> */}
                <ul style={{display:'flex', gap:'40px'}} className="text-sm footer-mb-gap">
                  <li className='footer-helping-links footer-mbl' style={{ color: theme.footerli, fontSize: '16px', fontWeight: '500', lineHeight: '25.5px' }}><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li className='footer-helping-links footer-mbl' style={{ color: theme.footerli, fontSize: '16px', fontWeight: '500', lineHeight: '25.5px' }}><Link to="/terms-of-service">Terms of Service</Link></li>
                  <li className='footer-helping-links footer-mbl' style={{ color: theme.footerli, fontSize: '16px', fontWeight: '500', lineHeight: '25.5px' }}><Link to="/">Home</Link></li>
                  {/* <li className='footer-helping-links' style={{ color: theme.footerli, fontSize: '16px', fontWeight: '500', lineHeight: '25.5px' }}><Link to="/terms-of-service">Contact us</Link></li> */}
                  {/* <li className='footer-helping-links' style={{ color: theme.footerli, fontSize: '14px', fontWeight: '400', lineHeight: '25.5px' }}><Link to="/contact-us">Contact Us</Link></li> */}
                </ul>
              </div>
            <div className="footer-border"></div>
            <span className='footer-f cursor' style={{fontSize:'14px', fontWeight:400, color:theme.leadPopupSubHeading}}> Autoolic. All rights reserved. © 2025</span>
          </div>

          {/* Bottom Section */}
          <div style={{ color: theme.footerH3, justifyContent: 'center', fontSize: '14px', fontWeight: '400', lineHeight: '25.5px', display: 'flex', alignItems: 'center' }} className="text-center text-sm text-gray-500 flex flex-col gap-5 sm:flex-row sm:gap-0">
            {/* <div className="flex space-x-4 w-[41%]">
              <a href="#" aria-label="LinkedIn">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center"
                  style={{
                    background: 'linear-gradient(314.03deg, #FB5F65 -0.15%, #F378C9 100.63%)',
                    backgroundBlendMode: 'overlay',
                  }}>
                  <span>
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_3155_15872)">
                        <g clipPath="url(#clip1_3155_15872)">
                          <path fillRule="evenodd" clipRule="evenodd" d="M15.4174 14.5642C15.4193 14.7484 15.3597 14.8014 15.1811 14.7967C14.6721 14.7826 14.1627 14.7836 13.6537 14.7995C13.3979 14.8107 13.3216 14.7437 13.3253 14.4786C13.3402 13.3335 13.33 12.1874 13.3327 11.0423C13.3327 10.7288 13.3114 10.4172 13.196 10.1214C13.0007 9.62186 12.6639 9.28418 12.1058 9.23488C11.5104 9.18279 11.0788 9.45349 10.7876 9.95488C10.596 10.2833 10.5523 10.6507 10.5532 11.0256C10.556 12.1828 10.5467 13.34 10.5597 14.4963C10.5634 14.7456 10.4872 14.8079 10.249 14.7995C9.74 14.7843 9.23065 14.7837 8.72159 14.7977C8.52624 14.8023 8.4667 14.7437 8.4667 14.5465C8.47322 12.1633 8.47228 9.78 8.46856 7.39674C8.46856 7.22558 8.50298 7.14837 8.69554 7.15302C9.23973 7.16418 9.78391 7.16418 10.3272 7.15302C10.5151 7.1493 10.5644 7.21814 10.5569 7.39395C10.5448 7.6786 10.5541 7.96511 10.5541 8.32418C11.3607 7.32883 12.3309 7.00139 13.4834 7.23395C14.5997 7.45907 15.3681 8.46372 15.3997 9.80976C15.4369 11.393 15.4081 12.9791 15.4174 14.5642ZM6.03787 6.26651C5.87832 6.26727 5.72022 6.23617 5.57286 6.17501C5.4255 6.11386 5.29183 6.02388 5.17971 5.91037C5.06758 5.79686 4.97926 5.6621 4.91992 5.514C4.86058 5.36589 4.83142 5.20743 4.83415 5.0479C4.83389 4.72599 4.96102 4.41706 5.18777 4.18857C5.41452 3.96007 5.72248 3.83058 6.04438 3.82837C6.36627 3.83205 6.67359 3.96314 6.89903 4.19294C7.12447 4.42274 7.24965 4.73251 7.24717 5.05441C7.24929 5.21394 7.21948 5.37228 7.15949 5.52011C7.0995 5.66794 7.01055 5.80228 6.89787 5.91522C6.78519 6.02816 6.65105 6.11742 6.50336 6.17775C6.35566 6.23808 6.1974 6.26826 6.03787 6.26651ZM6.78577 14.7995C6.27707 14.7836 5.76802 14.7826 5.25926 14.7967C5.07694 14.8005 4.99508 14.767 4.99508 14.5549C5.00252 12.1735 5.00159 9.79209 4.99601 7.41069C4.99601 7.21907 5.04159 7.14744 5.24531 7.15302C5.76531 7.16604 6.28624 7.16976 6.80531 7.15116C7.04438 7.14279 7.0881 7.23116 7.08717 7.4479C7.07787 8.62744 7.08252 9.80604 7.08252 10.9856C7.08252 12.153 7.07601 13.3205 7.0881 14.4888C7.09089 14.726 7.03601 14.8098 6.78577 14.7995ZM18.156 4.38837C18.1095 4.00883 18.1021 3.61907 17.8937 3.28046C17.2155 2.18093 16.2807 1.55488 14.9411 1.56232C11.5504 1.58 8.15973 1.56232 4.7681 1.57441C4.25926 1.57534 3.73554 1.59302 3.27322 1.86558C2.14391 2.53441 1.48066 3.4693 1.4881 4.83767C1.50391 8.23953 1.4881 11.6414 1.49926 15.0442C1.50112 15.5233 1.50856 16.0256 1.75973 16.4572C2.35229 17.4786 3.13368 18.2367 4.4174 18.2321C4.45461 18.2321 4.48252 18.2488 4.51415 18.2656H15.2062C15.2648 18.2126 15.3374 18.2386 15.4044 18.2302C15.7886 18.1819 16.1858 18.18 16.5272 17.9605C17.4807 17.3428 18.1821 16.567 18.1607 15.3391C18.1607 15.3177 18.1755 15.2981 18.1923 15.2805V4.58837C18.1439 4.5279 18.1644 4.45534 18.156 4.38837Z" fill="white" />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_3155_15872">
                          <rect width="17.8605" height="17.8605" fill="white" transform="translate(0.930176 0.930176)" />
                        </clipPath>
                        <clipPath id="clip1_3155_15872">
                          <rect width="22.3256" height="22.3256" fill="white" transform="translate(-1.30249 -1.22827)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </div>
              </a>
              <a href="#" aria-label="Twitter">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center"
                  style={{
                    background: 'linear-gradient(314.03deg, #FB5F65 -0.15%, #F378C9 100.63%)',
                    backgroundBlendMode: 'overlay',
                  }}>
                  <span>

                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.2736 8.81794L16.6727 2.67871H14.2557L10.1449 7.27809L6.60004 2.72305L1.51855 2.67871L7.45784 10.4706L1.90311 17.0339H4.31849L8.74454 12.1226L12.6296 17.1452L17.6426 17.1903L11.2736 8.81794ZM4.3193 4.06296H5.85511L14.7072 15.6948H13.2851L4.3193 4.06296Z" fill="white" />
                    </svg>

                  </span>
                </div>
              </a>
              <a href="#" aria-label="Instagram">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center"
                  style={{
                    background: 'linear-gradient(314.03deg, #FB5F65 -0.15%, #F378C9 100.63%)',
                    backgroundBlendMode: 'overlay',
                  }}>
                  <span>

                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_3155_15878)">
                        <g clipPath="url(#clip1_3155_15878)">
                          <path d="M9.1826 7.6653C8.77048 7.6653 8.36761 7.78751 8.02495 8.01647C7.68228 8.24543 7.4152 8.57086 7.25749 8.95161C7.09978 9.33236 7.05852 9.75133 7.13892 10.1555C7.21932 10.5597 7.41777 10.931 7.70919 11.2224C8.0006 11.5138 8.37188 11.7123 8.77608 11.7927C9.18029 11.8731 9.59925 11.8318 9.98 11.6741C10.3608 11.5164 10.6862 11.2493 10.9151 10.9067C11.1441 10.564 11.2663 10.1611 11.2663 9.74902C11.2673 9.4751 11.2141 9.2037 11.1097 8.95045C11.0053 8.6972 10.8519 8.4671 10.6582 8.27341C10.4645 8.07972 10.2344 7.92628 9.98117 7.82191C9.72791 7.71754 9.45651 7.66431 9.1826 7.6653Z" fill="white" />
                          <path fillRule="evenodd" clipRule="evenodd" d="M12.0478 2.41895H6.32498C5.14076 2.41895 4.00504 2.88938 3.16767 3.72675C2.33029 4.56412 1.85986 5.69984 1.85986 6.88406V12.6069C1.85986 13.7911 2.33029 14.9268 3.16767 15.7642C4.00504 16.6015 5.14076 17.072 6.32498 17.072H12.0478C13.232 17.072 14.3677 16.6015 15.2051 15.7642C16.0425 14.9268 16.5129 13.7911 16.5129 12.6069V6.88406C16.5129 5.69984 16.0425 4.56412 15.2051 3.72675C14.3677 2.88938 13.232 2.41895 12.0478 2.41895ZM9.18265 12.9417C8.33396 12.9398 7.52081 12.6007 6.92209 11.9992C6.32337 11.3977 5.98812 10.583 5.9901 9.73429C5.99207 8.8856 6.3311 8.07245 6.93262 7.47373C7.53413 6.87501 8.34884 6.53976 9.19754 6.54174C9.61777 6.54271 10.0337 6.62645 10.4216 6.78817C10.8094 6.94989 11.1616 7.18642 11.4581 7.48426C11.7546 7.7821 11.9894 8.13541 12.1494 8.52402C12.3093 8.91264 12.3911 9.32895 12.3901 9.74918C12.3891 10.1694 12.3054 10.5853 12.1437 10.9732C11.9819 11.3611 11.7454 11.7133 11.4476 12.0097C11.1497 12.3062 10.7964 12.5411 10.4078 12.701C10.0192 12.8609 9.60288 12.9427 9.18265 12.9417ZM11.9622 6.07439C12.0245 6.22287 12.1297 6.34943 12.2642 6.43796C12.3987 6.52649 12.5565 6.57298 12.7175 6.5715C12.8231 6.5715 12.9276 6.55071 13.0251 6.51032C13.1226 6.46993 13.2112 6.41073 13.2859 6.3361C13.3605 6.26147 13.4197 6.17287 13.4601 6.07535C13.5005 5.97784 13.5213 5.87333 13.5213 5.76778C13.5224 5.64737 13.4966 5.52823 13.4459 5.419C13.3953 5.30978 13.3209 5.2132 13.2282 5.13629C13.1356 5.05938 13.027 5.00406 12.9103 4.97435C12.7936 4.94464 12.6718 4.94127 12.5536 4.96451C12.4355 4.98775 12.324 5.03699 12.2272 5.10868C12.1305 5.18037 12.0509 5.2727 11.9943 5.37896C11.9376 5.48523 11.9054 5.60277 11.8998 5.72306C11.8943 5.84335 11.9156 5.96336 11.9622 6.07439Z" fill="white" />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_3155_15878">
                          <rect width="17.8605" height="17.8605" fill="white" transform="translate(0.371582 0.929932)" />
                        </clipPath>
                        <clipPath id="clip1_3155_15878">
                          <rect width="17.8605" height="17.8605" fill="white" transform="translate(0.371582 0.929932)" />
                        </clipPath>
                      </defs>
                    </svg>

                  </span>
                </div>
              </a>
            </div> */}
           
          </div>
        </div>
      </footer>
    </div>
  );
}
